import { Field } from 'formik';
import {
  NumberInput,
  NumberInputField,
  NumberInputStepper,
  NumberIncrementStepper,
  NumberDecrementStepper,
  FormControl,
} from '@chakra-ui/react';
import ElementInstructions from './components/ElementInstructions';
import ElementHeading from './components/ElementHeading';
import ElementErrorMessage from './components/ElementErrorMessage';
import InputWrapper from './components/InputWrapper';

const Number = ({ fieldName, qObj, props, index }) => {
  let nValue = props.formikProps.values.jobSeekerData[index][qObj.qid];
  nValue = typeof nValue === 'undefined' ? 0 : nValue;
  /*Chakra UI Bug
  On the NumberInput element if the first "attempt" to render has an undefined value
  Then the number field will have no value.
  so unlike other Chakra Elements you have to check if the value is undefined.
  */
  return (
    <Field name={fieldName}>
      {({ field, form }) => (
        <FormControl isInvalid={form.errors[qObj.id] && form.touched[qObj.id]}>
          <ElementHeading qObj={qObj} props={props} />
          <ElementInstructions instructions={qObj.instructions} />
          <InputWrapper>
            <NumberInput defaultValue={nValue}>
              <NumberInputField />
              <NumberInputStepper>
                <NumberIncrementStepper />
                <NumberDecrementStepper />
              </NumberInputStepper>
            </NumberInput>
          </InputWrapper>
          <ElementErrorMessage form={form} index={qObj.index} qid={qObj.qid} />
        </FormControl>
      )}
    </Field>
  );
};

export default Number;
